<template>
  <div class="build">
    <div id="title">
        <h1>金石建案</h1>
    </div> 
    <div class="container">
        <div class="about-photos-mb">
          <div class="photo-container-mb">
            <img v-show="carouselId == pic.id"
                :src="require(`@/assets/carousel2x/${pic.photo}@2x.png`)"
                class="photo-mb" v-for="pic in carousel" :key="pic.id">
          </div>
            <span class="photo-text-mb" v-show="carouselId == pic.id"
              v-for="pic in carousel" :key="pic.id">{{pic.description}}</span>
                <div class="dot-container-mb">             
                  <span v-for="pic in carousel" @click="changecarousel(pic)"
                        :key="pic.id" :class="{dotsmb: carouselId !== pic.id, dotsactivemb : carouselId == pic.id}"></span>
                </div>              
        </div>
    <div class="btnbox">
      <button class="seemore"><a><router-link to='/mobileAdvocate'>看更多</router-link></a></button>
    </div>
    </div>

  </div>
  
</template>
 
<script>
export default {
  data(){
    return {     
      carouselId: 1,
      carousel:[
        {id:1,description:'金石PLUS',photo:'gold_plus'},
        {id:2,description:'金石首品II',photo:'gold_ii'},
        {id:3,description:'金石LV',photo:'gold_lv'},
        {id:4,description:'金石全方位要求完美，嚴謹施工',photo:'hands'},
      ],
      }
  },
  created () {
      window.addEventListener('scroll', this.handleScroll);   
      this.interval = setInterval(() => this.runningcarousel(), 6500);
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
      changecarousel(pic){
        this.carouselId = pic.id
        //console.log(this.carouselId)
      },
      runningcarousel(){
          this.carouselId = this.carouselId + 1 
          if(this.carouselId== 5){
            this.carouselId = 1
          }
  }
  }

}
</script>
<style scoped>
.build{
  width: 100%;
  height: auto;
  margin:85px 0 0 0;
}

#title h1{
  text-align: center;
  margin: 0% auto 12% auto;
  width: 100%;
  height: auto;
  padding: 1% 0;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.93px;
  color: #a89a80;
}

.container{
  width: 90%;
  height: auto;
  margin:  5% auto 5% auto;
  text-align:center;
  /* background-image: linear-gradient(to top, #c4c3c230 41%, #dadad93a 60%, #feffff79 100%); */
}

.about-photos-mb{
  width: 100%;
  height: auto;
  margin: 3% 0 10% 0;
  text-align: center;
  /* background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff); */
}

.photo-container-mb{
  width: 100%;
  height: auto;
  overflow:hidden;
}
@keyframes showupfotomb{
  0%{opacity: 0.75}
  80%{opacity: 0.85}
  100%{opacity: 0.7}
}
.photo-mb{
  width: 100%;
  height: 235px;
  /* object-fit: contain; */
  opacity: 0.75;
  margin-right: 50px;
  animation: showupfotomb 6.5s ease-out forwards;
  -webkit-animation: showupfotomb 6.5s ease-out forwards;
}
.photo-mb:hover{  
  opacity: 1.0 !important; }

.photo-text-mb{
  text-align: center;
  width: 100%;
  margin: 1% auto;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.32px;
  color: #8f8f8f;
}
.dot-container-mb{ 
  height:auto; width:100%;
  margin: 0% auto;
  text-align: center;
  vertical-align:middle;
  }
.dotsmb{
  display: inline-block;
  padding: 2px;
  margin: 0% 3%;
  border-radius: 50%;
  border: solid 1px #d8d8d8;
  background-color: #d8d8d8;
}
.dotsactivemb{
  display: inline-block;
  padding: 2px;
  margin: 0% 3%;
  border-radius: 50%;
  background: #d0ad76;
  border: 1px solid #d0ad76;
}
.dotsmb:hover, .dotsactivemb:hover{cursor: pointer;}


.btnbox{
  width:100%;
  height: auto;
  margin: 12% auto 0% auto;
  text-align:center;
}

.seemore {
  text-align:center;
  width: auto;
  height: auto;
  padding: 1% 5%;
  margin: 0 auto;
  border: solid 1px rgba(196, 182, 156, 0.521);
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  background: transparent;
}
.seemore a{
  text-decoration:none;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  }

.seemore:active {
  text-align:center;
  width: auto;
  height: auto;
  padding: 1% 5%;
  margin: 0 auto;
  border: solid 0.5px #BDAA87;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #BDAA87;
  background: #BDAA87;
}
.seemore a:active{
  text-decoration:none;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #ffffff;
  }
</style>